// Mirrors apps/api/src/util/placeholderEmail.ts: the address a manual order taken without an email
// is stored under. It can never receive mail, so the admin shows it as missing.
export function isPlaceholderEmail(email: string): boolean {
  return email.trim().toLowerCase().endsWith('@manual.local');
}
